module.exports = __webpack_public_path__ + "static/img/gaozhongdili2.1ac9b657.jpg";